import { FieldNumberOutlined, MedicineBoxOutlined, EnvironmentOutlined, PhoneOutlined } from '@ant-design/icons';
import { Col, Row, Button } from 'antd';
import { Formik } from 'formik';
import { Form, Input, SubmitButton } from 'formik-antd';
import { useSelector } from 'react-redux';
import { RootState } from 'types/store';
import Wrap from './styles';

type InitialValue = {
  facility_name: string;
  address: string;
  phone: string;
  code: string;
};

type Props = {
  onSearch: (value: any) => void;
};

const SearchMedicalInstitution = ({ onSearch }: Props) => {
  const { searchValue } = useSelector((state: RootState) => state.medicals);
  const handleSubmit = (values: InitialValue, form: any) => {
    form.setSubmitting(false);
    onSearch(values);
  };
  const resetForm = (value: InitialValue) => {
    onSearch(undefined);
  };

  return (
    <Wrap>
      <Formik
        onSubmit={handleSubmit}
        initialValues={searchValue}
        onReset={resetForm}
        render={() => (
          <Form>
            <Row className="detail">
              <Col span={15}>
                <Row>
                  <Col span={12} className="search">
                    <MedicineBoxOutlined className="icon1" />
                    <p className="standardBoldFont">医療機関名</p>
                    <Form.Item name="facility_name">
                      <Input className="input-search" name="facility_name" />
                    </Form.Item>
                  </Col>
                  <Col span={11} style={{ marginLeft: '5px' }} className="search">
                    <PhoneOutlined className="icon1" />
                    <p className="standardBoldFont">TEL</p>
                    <Form.Item name="phone">
                      <Input className="input-search" name="phone" />
                    </Form.Item>
                  </Col>
                  <Col span={11} className="search">
                    <EnvironmentOutlined className="icon1" />
                    <p className="standardBoldFont">所在地</p>
                    <Form.Item name="address">
                      <Input className="input-search" name="address" />
                    </Form.Item>
                  </Col>
                  <Col span={13} className="search">
                    <FieldNumberOutlined className="icon1" />
                    <p className="standardBoldFont">取引先番号</p>
                    <Form.Item name="code">
                      <Input className="input-search" name="code" />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col span={7} offset={2} className="btn">
                <Button htmlType="reset" className="Standard backSetup">
                  リセット
                </Button>
                <SubmitButton className="btnSearch Standard btnDefault">絞り込み表示</SubmitButton>
              </Col>
            </Row>
          </Form>
        )}
      />
    </Wrap>
  );
};

export default SearchMedicalInstitution;
